<script lang="ts">
	import type { HelpPalletsProps } from "./HelpPalletsProps.js";
	import HelpPage from "../components/HelpPage.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import helpArea from "../assets/images/storage-area.png";

	type $$Props = HelpPalletsProps;

	const { references, products, categories, blogPosts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, helpArea);
</script>

<HelpPage
	heading="Chci skladovou plochu navíc"
	perex="Naše mezaninové plošiny a víceúrovňové systémy umožňují vytvořit další skladovací plochu, aniž byste museli rozšiřovat svůj sklad. Získáte tak více prostoru pro manipulaci i skladování s minimálními náklady a stavebními úpravami."
	{references}
	{products}
	{categories}
	{blogPosts}
>
	<p slot="subHeading">
		{nbspify("Pokud potřebujete")}
		<span class="text-primary">{nbspify("rozšířit skladovací kapacitu,")}</span>
		{nbspify("nabízíme efektivní řešení, která vám pomohou maximálně využít dostupný prostor.")}
	</p>
</HelpPage>
